<div *ngIf="attributions && attributions.length > 0" class="row-auto attributions">
    <div
        *ngFor="let item of attributions"
        class="attribution col-xs-6 p-xs-3 col-lg-4 col-xl-2 selenium-attribution"
    >
        <app-logo [logoUrl]="item.logoColor" [name]="item.name" [role]="item.getRoles()"></app-logo>
    </div>
</div>
